import {DEFAULT_CULTURE} from '../base.js'
import {
  BUGGIES_CATEGORY1_ID,
  CLASSICS_CATEGORY1_ID,
  DEFAULT_OFFER_TYPE_ID,
  MINIMOTOS_CATEGORY1_ID,
  MOTOS_CATEGORY1_ID,
  OFFER_TYPE_NEW,
  QUADS_CATEGORY1_ID,
  UNSELECTED_OFFER_TYPE
} from './ads.js'
import {ADS_LIST_SEMANTIC_ELECTRIC, ADS_LIST_SEMANTIC_PRIVATE_SELLER} from './page.js'

export const NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS = 'NOINDEX, NOFOLLOW'
export const CRAWLABLE_AND_INDEXABLE_META_ROBOTS = 'INDEX, FOLLOW'
export const DEVELOPMENT_META_ROBOTS = NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS

export const META_ROBOTS_NO_INDEX_NO_FOLLOW = {content: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS, name: 'robots'}

export const HAS_STATIC_FAQS_ENABLED = false
export const HAS_RENTING_SEO_SLUG_INFO_ENABLED = false

export const STRUCTURED_DATA_VEHICLE_TYPE = 'Motorcycle'

export const SEMANTIC_KEYWORDS = {
  RENTING: {}
}

export const ADS_LIST_TITLES = {
  [MOTOS_CATEGORY1_ID]: {'es-ES': 'Motos'},
  [QUADS_CATEGORY1_ID]: {'es-ES': 'Quads'},
  [BUGGIES_CATEGORY1_ID]: {'es-ES': 'Buggies'},
  [MINIMOTOS_CATEGORY1_ID]: {'es-ES': 'Minimotos'},
  [CLASSICS_CATEGORY1_ID]: {'es-ES': 'Clásicas y competición'}
}

export const litresLiteral = {
  'es-ES': '%{litres} cc'
}

export const cheapLiteral = {
  'es-ES': 'baratas'
}

export const paginationLiteral = {
  'es-ES': 'Página'
}

export const locatedInLiteral = {
  'es-ES': 'en %{location}'
}

export const dealerWithMakeLiteral = {
  'es-ES': 'con %{make} en venta'
}

const NEWS_RSS_ALTERNATE = {
  TYPE: 'application/rss+xml',
  TITLE: 'motos.net Noticias (RSS)',
  URL: 'https://motos.coches.net/noticias/rss/?maxrows=50'
}

export const SEO_RENTING_HARDCODED_SCHEMA_DATA = []

const adsListDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      '%{nResults} %{type} %{make} %{model} %{fuelType} %{bodyType} %{category2} %{litres} %{cheap} de segunda mano y ocasión, venta de motos usadas %{toponym} | Motos.net %{pagination}',
    H1: '%{type} %{make} %{model} %{fuelType} %{bodyType} %{category2} %{litres} %{cheap} de segunda mano y ocasión %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{make} %{model} %{fuelType} %{bodyType} %{category2} %{litres} %{cheap} de particulares y concesionarios de segunda mano y ocasión %{toponym}. ¡Encuentra %{make} %{model} al mejor precio %{toponym} por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListAllVehiclesDefaultMeta = {
  'es-ES': {
    CANONICAL: '',
    TITLE:
      '%{nResults} %{type} %{make} %{model} %{fuelType} %{bodyType} %{category2} %{litres} %{cheap} nuevas y de segunda mano %{toponym} | Motos.net %{pagination}',
    H1: '%{type} %{make} %{model} %{fuelType} %{bodyType} %{category2} %{litres} %{cheap} nuevas y de segunda mano %{toponym}',
    META_DESCRIPTION: '',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

const adsListNewEmptyMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: 'Motos nuevas. Ofertas especiales | Motos.net %{pagination}',
    H1: 'Motos nuevas',
    META_DESCRIPTION:
      'El mayor portal de motos nuevas en España. Todos los modelos y marcas al mejor precio. ¡Tu próxima moto está aquí!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListNewDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{nResults} %{type} %{make} %{model} %{fuelType} %{bodyType} nuevas %{toponym} | Motos.net %{pagination}',
    H1: '%{type} %{make} %{model} %{fuelType} %{bodyType} nuevas %{toponym}',
    META_DESCRIPTION:
      'El mayor portal de %{type} nuevas %{make} %{model} %{fuelType} %{bodyType} de España %{toponym}. Todos los modelos y marcas al mejor precio. ¡Tu próxima moto está aquí!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticPrivateSellerDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{type} de segunda mano y ocasión de particulares, venta de motos usadas | Motos.net %{pagination}',
    H1: '%{type} de segunda mano y ocasión de particulares',
    META_DESCRIPTION:
      '%{nResults} %{type} de segunda mano y ocasión de particulares. ¡Encuentra al mejor precio por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticPrivateSellerProvinceMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      '%{nResults} %{type} de segunda mano y ocasión de particulares %{toponym}, venta de motos usadas | Motos.net %{pagination}',
    H1: '%{type} de segunda mano y ocasión de particulares %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} de segunda mano y ocasión de particulares %{toponym}. ¡Encuentra al mejor precio por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticElectricDefaultMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE: '%{type} %{make} eléctricas de segunda mano y ocasión, venta de motos usadas | Motos.net %{pagination}',
    H1: '%{type} %{make} eléctricas de segunda mano y ocasión',
    META_DESCRIPTION:
      '%{nResults} %{type} %{make} eléctricas de segunda mano y ocasión. ¡Encuentra al mejor precio por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListSemanticElectricProvinceMeta = {
  'es-ES': {
    CANONICAL: '%{canonical}',
    TITLE:
      '%{nResults} %{type} %{make} eléctricas de segunda mano y ocasión %{toponym}, venta de motos usadas | Motos.net %{pagination}',
    H1: '%{type} %{make} eléctricas de segunda mano y ocasión %{toponym}',
    META_DESCRIPTION:
      '%{nResults} %{type} %{make} eléctricas de segunda mano y ocasión %{toponym}. ¡Encuentra al mejor precio por marca y modelo!',
    META_ROBOTS: '%{metaRobots}'
  }
}

const adsListMeta = {
  [DEFAULT_OFFER_TYPE_ID]: {
    default: adsListDefaultMeta,
    semanticPrivateSellerDefault: adsListSemanticPrivateSellerDefaultMeta,
    semanticPrivateSellerProvince: adsListSemanticPrivateSellerProvinceMeta,
    semanticElectricDefault: adsListSemanticElectricDefaultMeta,
    semanticElectricProvince: adsListSemanticElectricProvinceMeta
  },
  [OFFER_TYPE_NEW]: {
    default: adsListNewDefaultMeta,
    empty: adsListNewEmptyMeta
  },
  [UNSELECTED_OFFER_TYPE]: {
    default: adsListAllVehiclesDefaultMeta
  }
}

export const adsListSemanticMapper = {
  [ADS_LIST_SEMANTIC_PRIVATE_SELLER]: {
    default: 'semanticPrivateSellerDefault',
    province: 'semanticPrivateSellerProvince'
  },
  [ADS_LIST_SEMANTIC_ELECTRIC]: {
    default: 'semanticElectricDefault',
    province: 'semanticElectricProvince'
  }
}

export const adsListMetaMapper = {
  [MOTOS_CATEGORY1_ID]: {...adsListMeta},
  [QUADS_CATEGORY1_ID]: {...adsListMeta},
  [BUGGIES_CATEGORY1_ID]: {...adsListMeta},
  [MINIMOTOS_CATEGORY1_ID]: {...adsListMeta},
  [CLASSICS_CATEGORY1_ID]: {...adsListMeta}
}

// subscription is not a Motos product yet, just leaving config values for compatibility
export const subscriptionAdsList = {
  'es-ES': {}
}

// subscription is not a Motos product yet, just leaving config values for compatibility
export const subscriptionAdsListMakeMeta = {
  'es-ES': {}
}

export const dealersList = {
  default: {
    'es-ES': {
      TITLE: 'Todos los concesionarios de motos en España | Motos.net',
      H1: 'Concesionarios de motos en España',
      META_DESCRIPTION:
        'En motos.net tenemos los motos de los mejores concesionarios de España, en todas las provincias. ¡Entra y descubre los más cercanos!',
      META_ROBOTS: '%{metaRobots}'
    }
  },
  filtered: {
    'es-ES': {
      TITLE: 'Concesionarios de motos %{make} %{toponym} | Motos.net',
      H1: 'Concesionarios %{dealerMake} %{toponym}',
      META_DESCRIPTION:
        '¿Buscas un concesionario de motos %{make} %{toponym}? En motos.net puedes consultar online todos los vehículos de concesionarios %{make} %{toponym}.',
      META_ROBOTS: '%{metaRobots}'
    }
  }
}

export const instantOfferStandalone = {
  'es-ES': {
    H1: 'Vende tu moto a un comprador profesional',
    TITLE: 'Vende tu moto a un comprador profesional | Gratis y Seguro | Motos.net',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

export const insurance = {
  'es-ES': {
    CANONICAL: '',
    TITLE: 'Seguro motos',
    META_DESCRIPTION:
      'Compara entre las mejores ofertas de seguros de moto y ahorra con sus condiciones. Encuentra y asegura fácilmente tu vehículo gracias a Motos.net.',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const professionalStock = {
  'es-ES': {
    default: {
      TITLE: '%{name} - Concesionario en %{province} | Motos.net',
      META_DESCRIPTION:
        'Todos los vehículos del concesionario %{name} en %{province}. Descubre todas las ofertas de este concesionario en motos.net.',
      META_ROBOTS: 'INDEX, FOLLOW'
    },
    informacion: {
      TITLE: '%{name} Teléfono, Dirección, Horarios y más información | Motos.net',
      H1: '%{name} Teléfono, Dirección, Horarios y más información',
      META_DESCRIPTION:
        'Teléfono, Dirección, Horarios y más información de %{name}. Encuentra todo lo que necesitas saber para ponerte en contacto o visitar a %{name}.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  }
}

export const professionalRentingStock = {
  'es-ES': {
    default: {
      TITLE: '%{name} Renting - %{nResults} ofertas de renting | Motos.net',
      H1: '%{name} Renting',
      META_DESCRIPTION:
        '%{nResults} ofertas de renting de %{name}. Descubre todas las ofertas de renting de %{name} en motos.net.',
      META_ROBOTS: 'INDEX, FOLLOW'
    },
    informacion: {
      TITLE: '%{name} Renting Teléfono, Dirección, Horarios y más información | Motos.net',
      H1: '%{name} Renting Teléfono, Dirección, Horarios y más información',
      META_DESCRIPTION:
        'Teléfono, Dirección, Horarios y más información de %{name}. Encuentra todo lo que necesitas saber para ponerte en contacto o visitar a %{name} Renting.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  }
}

export const home = {
  'es-ES': {
    CANONICAL: '/',
    TITLE: 'Motos nuevas, de ocasión y seminuevas - Motos.net',
    META_DESCRIPTION:
      'El portal de motos líder en España. Anuncios de motos nuevas, motos de ocasión, motos de segunda mano, noticias de motos, vídeos y foros de motos.',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const staticSections = {
  login: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Login - Acceso de Usuario',
      META_DESCRIPTION: '',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'user-discounts': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Motos.net Club',
      META_DESCRIPTION: '',
      META_ROBOTS: 'NOINDEX,NOFOLLOW'
    }
  },
  'user-favorite-ads': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Mis favoritos | Motos.net',
      META_DESCRIPTION: '',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'user-profile': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Mi cuenta | Motos.net',
      META_DESCRIPTION: '',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'user-profile-edit': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Editar mis datos personales | Motos.net',
      META_DESCRIPTION: '',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'user-saved-searches': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Mis búsquedas | Motos.net',
      META_DESCRIPTION: '',
      META_ROBOTS: 'NOINDEX,NOFOLLOW'
    }
  },
  'user-alerts-matches': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Nuevos anuncios para mis alertas | Motos.net',
      META_DESCRIPTION: '',
      META_ROBOTS: 'NOINDEX,NOFOLLOW'
    }
  },
  'terms-of-service': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Condiciones generales de uso de Motos.net',
      META_DESCRIPTION: 'Consulta las condiciones de uso de Motos.net',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  transparency: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Transparencia de Motos.net',
      META_DESCRIPTION: 'Transparencia de Motos.net',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'other-partners': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Política de cookies Motos.net - entidades terceras',
      META_DESCRIPTION: 'Política de cookies Motos.net - entidades terceras',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  checkout: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Pago seguro | motos.net',
      META_DESCRIPTION: 'Formulario de pagos de Motos.net',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'checkout-success': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Pago realizado | Motos.net',
      META_DESCRIPTION: 'Pago realizado correctamente',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'checkout-error': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Pago no realizado | Motos.net',
      META_DESCRIPTION: 'Pago no realizado, ha habido problemas para realizar tu pago',
      NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-pending': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Compra en cola | Motos.net',
      META_DESCRIPTION: 'Compra en cola, te enviaremos un email cuando tu compra se acabe de procesar',
      NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-activation-error': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'No hemos podido activar tu producto | Motos.net',
      META_DESCRIPTION: 'No hemos podido activar tu producto, recibirás el reembolso de tu pago en los próximos días',
      NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-request-error': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'No se puede completar la compra | Motos.net',
      META_DESCRIPTION: 'El producto que estás intentando comprar no existe o no puede ser activado para este anuncio',
      NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-refund-error': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'No hemos podido activar tu compra | Motos.net',
      META_DESCRIPTION: 'Ha habido un problema con la activación de tu compra',
      NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  'checkout-unknown-error': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Error desconocido | Coches.net',
      META_DESCRIPTION:
        'Ha habido un error desconocido con tu compra, por favor contacta con nuestro equipo de soporte',
      META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  },
  comparador: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Comparador de motos | Motos.net',
      META_DESCRIPTION: 'Te ayudamos a elegir la moto para ti. Compara prestaciones y precios.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  net_assistant: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Net: el buscador de motos con IA | Motos.net',
      META_DESCRIPTION:
        'Olvídate de marcas y filtros. Cuéntale a Net lo que buscas y la IA de motos.net encuentra tu moto ideal entre miles de anuncios. Pruébalo, es gratis.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  products: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Dale más visibilidad a tu anuncio | Motos.net',
      META_DESCRIPTION: 'Listado de productos de visibilidad',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  'payment-ad-request': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Publica tu anuncio de pago | Motos.net',
      META_DESCRIPTION: 'Ya has llegado al límite de anuncios gratuitos',
      META_ROBOTS: 'INDEX,FOLLOW'
    }
  },
  professionals: {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Anúnciate como concesionario para vender más y mejor',
      H1: 'Anúnciate como concesionario para vender más y mejor',
      META_DESCRIPTION:
        'Si eres profesional tanto de moto nueva como moto de ocasión accede desde aquí para modificar tus anuncios publicados en Motos.net.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'ad-management-my-ads': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Mis anuncios | Motos.net',
      META_DESCRIPTION: '',
      META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
    }
  }
}

export const news = {
  'news-category': {
    portada: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/?pg=%{page}',
        TITLE: 'Noticias de motos, noticias de motociclismo y vídeos de motos | Motos.net',
        H1: 'Actualidad del motor y noticias de motos por marca',
        META_DESCRIPTION:
          'Todas las noticias de motos, noticias de motociclismo, comparativas, pruebas, novedades, y videos de motos, noticias de MotoGP y mundial de Superbikes.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    actualidad: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/actualidad/?pg=%{page}',
        TITLE: 'Últimas noticias de motos y noticias del sector de motociclismo',
        H1: 'Últimas noticias de motos',
        META_DESCRIPTION:
          'Todas las noticias de motos y de motor. Sigue la actualidad del sector automóvil con tests, vídeos comparativas y novedades de todas las marcas.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    novedades: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/novedades/?pg=%{page}',
        TITLE: 'Últimas novedades de motos y del sector del motociclismo | Motos.net',
        H1: 'Novedades de motos y últimos modelos por marca',
        META_DESCRIPTION:
          'Todas las novedades de motos y novedades de motociclismo. Los últimos modelos a prueba: valoración, imágenes y características técnicas.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    pruebas: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/pruebas/?pg=%{page}',
        TITLE: 'Últimas pruebas de motos y del sector del motociclismo | Motos.net',
        H1: 'Pruebas de motos',
        META_DESCRIPTION:
          'Todas las pruebas de motos y pruebas del sector del motociclismo. Cualidades, rendimiento, calidad-precio y características técnicas de los últimos modelos valorados por nuestros expertos.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    reportajes: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/reportajes/?pg=%{page}',
        TITLE: 'Reportajes | Motos.net',
        H1: 'Reportajes de motos',
        META_DESCRIPTION:
          'Motos.net acude a los eventos más destacados del mundo de las motos, para traerte las últimas noticias e imágenes.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    videos: {
      'es-ES': {
        ALTERNATE: NEWS_RSS_ALTERNATE,
        CANONICAL: '/noticias/videos/?pg=%{page}',
        TITLE: 'Últimos vídeos de motos y motociclismo | Motos.net',
        H1: 'Vídeos de motos',
        META_DESCRIPTION:
          'Todos los vídeos de motos y vídeos de motociclismo. Presentaciones, test y comparativas de los modelos más destacados del mercado.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    }
  },
  'news-tag': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '/noticias/t/%{tag}/?pg=%{page}',
      TITLE: '%{tag}: Noticias y actualidad | Motos.net',
      H1: 'Noticias y actualidad de %{tag}',
      META_DESCRIPTION:
        'Encuentra todas las noticias y novedades sobre %{tag}. Motos.net te trae lo mejor del mundo de las motos: pruebas, novedades, vídeos…',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'news-search': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '/consejos/?pg=%{page}',
      TITLE: '%{searchTerm}: Noticias y actualidad | Motos.net',
      H1: 'Noticias y actualidad de %{searchTerm}',
      META_DESCRIPTION:
        'Encuentra todas las noticias y novedades sobre %{searchTerm}. Motos.net te trae lo mejor del mundo de las motos: pruebas, novedades, vídeos…',
      META_ROBOTS: 'NOINDEX, NOFOLLOW'
    }
  },
  'news-section-tips': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '/consejos',
      TITLE: 'Consejos | Motos.net',
      H1: 'Consejos',
      META_DESCRIPTION:
        'Encuentra los mejores consejos para tu moto y tu seguridad, así como consejos de compra/venta de motos, normativas...',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'news-section-trends': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '/tendencias',
      TITLE: 'Tendencias | Motos.net',
      H1: 'Tendencias',
      META_DESCRIPTION: 'Vídeos, reportajes, entretenimiento... Toda la actualidad del motor sin salir de casa',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'news-detail': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '%{path}',
      TITLE: '%{title} | Noticias motos.net',
      META_DESCRIPTION: '%{description}',
      META_ROBOTS: 'INDEX, FOLLOW',
      META_ROBOTS_EXTENDED: 'max-image-preview:large'
    }
  },
  'news-comments': {
    'es-ES': {
      ALTERNATE: NEWS_RSS_ALTERNATE,
      CANONICAL: '%{path}',
      TITLE: 'Opiniones de %{title}',
      META_DESCRIPTION: 'Opiniones y comentarios sobre %{title}. Opiniones de expertos y usuarios sobre el %{title}',
      META_ROBOTS: 'INDEX, FOLLOW',
      META_ROBOTS_EXTENDED: 'max-image-preview:large'
    }
  }
}

export const technicalDetails = {
  'technical-details': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/',
      TITLE: 'Buscador de fichas técnicas | Motos.net',
      META_DESCRIPTION:
        'Busca entre todas las fichas técnicas existentes: las especificaciones técnicas y precios por modelos y versiones de todas las marcas de motos.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-comparator': {
    'es-ES': {
      CANONICAL: '/fichas_tecnicas/comparador/',
      TITLE: 'Comparador de motos nuevas | Motos.net',
      H1: 'Comparador de motos nuevas y descatalogadas',
      META_DESCRIPTION:
        'Te ayudamos a elegir la moto para ti. Compara prestaciones y precios, entre todos los modelos actuales y descatalogados.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-comparator-results': {
    'es-ES': {
      CANONICAL: '',
      TITLE: 'Comparador de motos nuevas | Motos.net',
      H1: 'Comparador de motos nuevas y descatalogadas',
      META_DESCRIPTION:
        'Te ayudamos a elegir la moto para ti. Compara prestaciones y precios, entre todos los modelos actuales y descatalogados.',
      META_ROBOTS: 'NOINDEX, NOFOLLOW'
    }
  },
  'technical-details-make': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/%{make}/',
      TITLE: 'Fichas técnicas y precios de %{make} por modelo | Motos.net',
      META_DESCRIPTION:
        'Descubre la información técnica y precios de todos los modelos de %{make}. Encuentra en Motos.net las mejores ofertas para motos nuevas de %{make}',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-model': {
    'es-ES': {
      CANONICAL: '/fichas_tecnicas/%{make}/%{model}/',
      TITLE: '%{make} del %{year} - Información técnica | Motos.net',
      H1: '%{make}',
      META_DESCRIPTION:
        'Información y ficha técnica de la versión %{make} del %{year}: encuentra todos los detalles y modelos similares en Motos.net.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-vehicle': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/%{make}/%{model}/%{versionId}/%{vehicleId}/',
      TITLE: 'Ficha técnica y precio de %{make} %{model} %{version} %{fuelType} %{year} | Motos.net',
      H1: '%{make} %{model}',
      META_DESCRIPTION: 'Información y ficha técnica de %{make} %{model} %{version} %{fuelType} %{year}',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-vehicle-without-version': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/fichas_tecnicas/%{make}/%{model}/%{vehicleId}/',
      TITLE: 'Ficha técnica y precio de %{make} %{model} %{fuelType} %{year} | Motos.net',
      META_DESCRIPTION: 'Información y ficha técnica de %{make} %{model} %{fuelType} %{year}',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-search': {
    'es-ES': {
      TITLE: 'Buscador de fichas técnicas | Motos.net',
      META_DESCRIPTION:
        'Busca entre todas las fichas técnicas existentes: las especificaciones técnicas y precios por modelos de todas las marcas de motos.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  },
  'technical-details-search-results': {
    'es-ES': {
      TITLE: 'Buscador de fichas técnicas | Motos.net',
      META_DESCRIPTION:
        'Busca entre todas las fichas técnicas existentes: las especificaciones técnicas y precios por modelos de todas las marcas de motos.',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  }
}

export const MAKES_DISTRIBUTOR_SEO = {
  'makes-distributor': {
    'es-ES': {}
  },
  'makes-sizes-distributor': {
    'es-ES': {}
  }
}

export const MODEL_DETAIL_SEO = {
  'model-detail': {
    'es-ES': {
      CANONICAL: '%{siteUrl}/s/%{makeSlug}/%{modelSlug}',
      H1: ' %{make} %{model}',
      TITLE: '%{make} %{model} precio, ofertas y datos técnicos | Motos.net',
      META_DESCRIPTION:
        'Descubre las ofertas actuales del %{make} %{model} incluyendo los precios del %{make} %{model} más actualizados del mercado. Revisa todas las características y datos técnicos junto con la opinión de nuestro equipo de expertos en Motos.net',
      META_ROBOTS: 'INDEX, FOLLOW'
    }
  }
}

export const makePageSeo = {
  [DEFAULT_CULTURE]: {}
}

export const publishMyAd = {
  'es-ES': {
    CANONICAL: '/publicar-mi-anuncio/',
    H1: 'Publica tu motocicleta en motos.net',
    TITLE: 'Vende tu moto rápido y al mejor precio en motos.net',
    META_DESCRIPTION:
      'Vende tu moto de manera rápida y sencilla en Motos.net. Publica tu anuncio fácilmente y conecta con miles de compradores interesados. ¡Vende tu moto hoy mismo y consigue el mejor precio!',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

export const publishMyAdCategory = {
  'es-ES': {
    H1: 'Elige el tipo de vehículo',
    TITLE: 'Vende tu moto rápido y al mejor precio en motos.net | Elige el tipo de vehículo',
    META_DESCRIPTION:
      '¿Pensando en vender tu moto? Elige el tipo de vehículo, para que puedas anunciarlo en Motos.net y aprovechar la visibilidad del mayor portal de venta online. ¡Publica tu anuncio gratis ahora!',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

export const publishYourAd = {
  'es-ES': {
    H1: 'Vende tu moto online fácil y rápido',
    TITLE: 'Vende tu moto rápido y al mejor precio en motos.net',
    META_DESCRIPTION:
      'Vende tu moto de manera rápida y sencilla en Motos.net. Obtén una tasación gratuita online, publica tu anuncio fácilmente y conecta con miles de compradores interesados. ¡Vende tu moto hoy mismo y consigue el mejor precio!',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const publishYourAdWithLocation = {
  'es-ES': {
    TITLE: 'Vende tu moto en %{location} desde motos.net rápido y al mejor precio',
    H1: 'Vende tu moto en %{location} fácil y rápido',
    META_DESCRIPTION:
      'Vender tu moto en %{location} es más sencillo que nunca. En motos.net te ofrecemos la mejor plataforma para vender tu moto en %{location} al mejor precio ya sea a profesionales o particulares.',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const editMyAd = {
  'es-ES': {
    CANONICAL: '/editar-mi-anuncio/',
    H1: 'Edita tu anuncio en motos.net',
    TITLE: 'Edita tu anuncio en motos.net',
    META_DESCRIPTION: 'Edita tu anuncio en motos.net',
    META_ROBOTS: NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
  }
}

const EMPTY_SEO = {
  TITLE: '',
  META_DESCRIPTION: '',
  NO_CRAWLABLE_NOR_INDEXABLE_META_ROBOTS
}
export const ADS_DETAIL = {
  'ads-detail': {
    default: {
      'es-ES': {
        TITLE: '%{bodyType} %{make} %{version} (%{year}) - %{price} € en %{province} | Motos.net.',
        H1: '%{title}',
        META_DESCRIPTION:
          '%{make} %{version} del %{year}, disponible en %{province} por %{price} €. %{kms} km, %{cc} cc. Las mejores ofertas de %{bodyType} en Motos.net.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    offerType: {
      'es-ES': {
        TITLE: '%{bodyType} %{make} %{version} (%{year}) - %{price} € en %{province} | Motos.net.',
        H1: '%{title}',
        META_DESCRIPTION:
          '%{make} %{version} del %{year}, disponible en %{province} por %{price} €. %{kms} km, %{cc} cc. Las mejores ofertas de %{bodyType} en Motos.net.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    },
    simple: {
      'es-ES': {
        TITLE: '%{title} - %{price} € en %{province} | Motos.net.',
        H1: '%{title}',
        META_DESCRIPTION: '%{title}, disponible en %{province} por %{price} €. Las mejores ofertas en Motos.net.',
        META_ROBOTS: 'INDEX, FOLLOW'
      }
    }
  },
  'ads-detail-preview': {
    default: {'es-ES': EMPTY_SEO},
    offerType: {'es-ES': EMPTY_SEO},
    simple: {'es-ES': EMPTY_SEO}
  }
}

export const landingFormalities = {
  'es-ES': {
    TITLE: 'Trámites para comprar y vender tu moto | Motos.net',
    META_DESCRIPTION:
      'Todos los trámites que necesitas conocer para la compra-venta de motos entre particulares: requisitos, documentación y recomendaciones.',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const landingFormalitiesSecurityGuidelines = {
  'es-ES': {
    TITLE: 'Compra-venta de motos segura | Motos.net',
    META_DESCRIPTION:
      'Compra y vende tu vehículo de forma segura gracias a nuestra guía. Evita las estafas más usadas en Internet tanto si eres particular como profesional.',
    META_ROBOTS: 'INDEX, FOLLOW'
  }
}

export const SPONSORED_REL_TAG = 'nofollow'

export const MAX_CHEAP_PRICE = 2000

export const DEFAULT_OPEN_GRAPH_TITLE = 'Motos nuevas, de ocasión y seminuevas - Motos.net'
export const DEFAULT_OPEN_GRAPH_DESCRIPTION =
  'El portal de motos líder en España. Anuncios de motos nuevas, motos de ocasión, motos de segunda mano, noticias de motos, vídeos y foros de motos.'
export const DEFAULT_OPEN_GRAPH_IMAGE = 'images/motos/icons/logo-square-rounded-512x512.png'

export const MUTABLE_PLACEHOLDERS = []

export const TAGCLOUD_LITERALS = {}

export const DEFAULT_AREA_SERVED = {
  'es-ES': 'España'
}
